import type { Translations } from '../../../types'

const profileDangerMessages: Translations = {
  "profile.danger.title": "Privacy e account",
  "profile.danger.subtitle": "Gestisci consensi, export dati e operazioni sensibili legate al tuo account.",
  "profile.danger.reset": "Ripristina preferenze",
  "profile.danger.disableAll": "Disattiva comunicazioni",
  "profile.danger.deploymentTest.badge": "Test release",
  "profile.danger.deploymentTest.title": "Deployment test release attiva",
  "profile.danger.deploymentTest.subtitle": "Verifica il redeploy controllando i metadata di versione qui sotto.",
  "profile.danger.deploymentTest.versionLabel": "Versione",
  "profile.danger.deploymentTest.buildLabel": "Build",
  "profile.danger.deploymentTest.commitLabel": "Commit",
  "profile.danger.deploymentTest.fallback": "n/d",
}

export default profileDangerMessages
